import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';

import LeaguesAdmin from './seasons/LeaguesAdmin';
import SeasonsAdmin from './seasons/SeasonsAdmin';
import AdminUsers from './adminUsers/adminUsers';
import UsersInvoiceDetails from './adminUsers/usersInvoiceDetails';
import MemberActiveUsers from './adminUsers/memberActiveUsers';
import UserEvents from './adminUsers/userEvents';
import Connections from './connections/connections';
import AdminPubEvents from './pub/adminPubEvents';
import PlayerMerging from './players/PlayerMerging';


class AdminMaster extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			selectedSection: '',
    	leaguesCount: 0,
    	seasonsCount: 0,
    	teamsCount: 0,
			playersCount: 0,
			gamesCount: 0,
			usersCount: 0,
			membersCount: 0,
		};
		// this.dummyfunction = this.dummyfunction.bind(this);
	}

	getCounts() {
		Axios.get('/api/leagues/count').then(responseLeagues => {
		Axios.get('/api/seasons/count').then(responseSeasons => {
		Axios.get('/api/teams/count').then(responseTeams => {
		Axios.get('/api/players/count').then(responsePlayers => {
		Axios.get('/api/results/gameResults/count').then(responseGames => {
		Axios.get('/api/users/count').then(responseUsers => {
		Axios.get('/api/users/countMembers').then(responseMembers => {
			
			this.setState({
				leaguesCount: responseLeagues.data.count,
				seasonsCount: responseSeasons.data.count,
				teamsCount: responseTeams.data.count,
				playersCount: responsePlayers.data.count,
				gamesCount: responseGames.data.count,
				usersCount: responseUsers.data.count,
				membersCount: responseMembers.data.count,
			});
		});
		});
		});
		});
		});
		});
		});
	}

	componentDidMount() {
		this.getCounts();
	}

  render() {
	  console.log('AdminMaster: render');

    return (
      <div>
        <div className="row">
        <div className="col-12 col-md-4">
					<h5>Sommaire Statelo</h5>
	        <div className="row col-12">
					<ul>
						<li>Ligues: {this.state.leaguesCount}</li>
						<li>Saisons: {this.state.seasonsCount}</li>
						<li>Équipes: {this.state.teamsCount}</li>
						<li>Joueurs: {this.state.playersCount}</li>
						<li>Parties: {this.state.gamesCount}</li>
						<li>Utilisateurs: {this.state.usersCount}</li>
						<li>Membres: {this.state.membersCount}</li>
					</ul>
	        </div>
        </div>
        </div>

        <div className="row">
        <div className="col-10">
					<h5>Menu Master</h5>

	        <div className="row">
	        <div className="col-12 col-md-3">
	          <button type="button" className="btn btn-primary btn-masterOptions" 
							onClick={() => this.setState({ selectedSection: 'leagues' })}>Ligues</button>
	          <button type="button" className="btn btn-primary btn-masterOptions" 
							onClick={() => this.setState({ selectedSection: 'seasons' })}>Saisons</button>
	          <button type="button" className="btn btn-primary btn-masterOptions" 
							onClick={() => this.setState({ selectedSection: 'memberActiveUsers' })}>Membres Statelo</button>
	        </div>

	        <div className="col-12 col-md-3">
	          <button type="button" className="btn btn-primary btn-masterOptions" 
							onClick={() => this.setState({ selectedSection: 'users' })}>Utilisateurs</button>
	          <button type="button" className="btn btn-primary btn-masterOptions" 
							onClick={() => this.setState({ selectedSection: 'usersInvoiceDetails' })}>Utilisateurs (Facturation)</button>
	          <button type="button" className="btn btn-primary btn-masterOptions" 
							onClick={() => this.setState({ selectedSection: 'userEvents' })}>Événements Utilisateurs</button>
	          <button type="button" className="btn btn-primary btn-masterOptions" 
							onClick={() => this.setState({ selectedSection: 'connections' })}>Connections</button>
	        </div>

	        <div className="col-12 col-md-3">
	          <button type="button" className="btn btn-primary btn-masterOptions" 
							onClick={() => this.setState({ selectedSection: 'adminPubEvents' })}>Pub Events</button>
	          <button type="button" className="btn btn-primary btn-masterOptions" 
							onClick={() => this.setState({ selectedSection: 'mergePlayers' })}>Fusion de joueurs</button>
	        </div>
	        </div>

        </div>
        </div>

        <hr/>

        {this.showSelectedSection()}
      </div>
    );
  }

	showSelectedSection() {
    switch (this.state.selectedSection) {
      case 'leagues':
        return <LeaguesAdmin />;
      case 'seasons':
        return <SeasonsAdmin />;
      case 'memberActiveUsers':
        return <MemberActiveUsers />;
      case 'users':
        return <AdminUsers />;
      case 'usersInvoiceDetails':
        return <UsersInvoiceDetails />;
      case 'userEvents':
        return <UserEvents />;
      case 'connections':
        return <Connections />;
      case 'adminPubEvents':
        return <AdminPubEvents />;
      case 'mergePlayers':
        return <PlayerMerging />;

      default:
        return null;
    }
	}

}

export default AdminMaster;
